export const INIT_ENVIROMENT = 'ENVIRONMENT/INIT';
